import React from 'react';
import { NavLink } from 'react-router-dom';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

export default function NavigationItem({icon, text, to, children}) {
  return (
    <>
      <ListItem button component={NavLink} activeClassName="Mui-selected" to={to}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={text} />
      </ListItem>
      {children}
    </>
  )
}
